var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"m-b-16",attrs:{"cols":"12","xxl":"10"}},[_c('MainBlock',{staticClass:"m-b-16"}),_c('SubscriptionBlock')],1),(_vm.isDesktopScreen)?_c('b-col',{staticClass:"m-b-16",attrs:{"cols":"2"}},[_c('FiltersCard')],1):_vm._e()],1),_c('SubscriptionConfirmModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }